<script lang="ts" setup>
const attrs = useAttrs();

const bgSrc = computed(() => (typeof attrs.bgSrc === 'string' ? attrs.bgSrc : '/block/hero/blue-bus.webp'));
</script>

<template>
    <div class="relative min-h-screen">
        <div class="absolute inset-0 hidden items-center justify-center xl:flex">
            <img loading="lazy" :src="bgSrc" alt="Background" class="h-[438px] w-[1660px] object-cover object-left" aria-hidden="true" />
        </div>

        <div class="relative flex min-h-screen justify-center bg-white xl:w-1/2 xl:drop-shadow-2xl">
            <main class="flex w-full max-w-[640px] grow flex-col justify-between px-4 py-12 md:px-24">
                <slot />
            </main>
        </div>
    </div>
</template>
